import {lazy} from 'react'

export const DefaultCourseRedirectHandler = lazy(
  () => import('../../../components/default-course-redirect'),
)

export const CourseRedirectHandler = lazy(() => import('../../../components/course-redirect'))

export const MathAssignmentsCourseRedirectHandler = lazy(
  () => import('../../../components/math-assignments-course-redirect'),
)
